import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

const icon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.444 5.489c-2.033-.407-2.91-1.387-3.317-3.37a.25.25 0 0 0-.241-.189.25.25 0 0 0-.241.192c-.407 2.033-1.335 2.96-3.317 3.367a.254.254 0 0 0 0 .508c2.033.407 2.906 1.366 3.313 3.349a.25.25 0 0 0 .245.21.25.25 0 0 0 .243-.197c.406-2.034 1.333-2.955 3.315-3.362a.254.254 0 1 0 0-.508Z" fill="#e6f0ff"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21.223 5.24a3.057 3.057 0 0 0-4.323 0L6.87 15.267a5.419 5.419 0 0 0-1.295 2.08l-1.12 3.282a1.087 1.087 0 0 0 1.378 1.38L9.1 20.896a5.42 5.42 0 0 0 2.086-1.299L21.223 9.562a3.057 3.057 0 0 0 0-4.323Zm-2.134 4.334 1.073-1.073A1.557 1.557 0 1 0 17.961 6.3l-1.073 1.073 2.201 2.201Zm-1.06 1.06-2.202-2.2-6.633 6.632a6.214 6.214 0 0 1 2.2 2.204l6.635-6.635Zm-7.743 7.744a4.71 4.71 0 0 0-2.199-2.204l-.156.155a3.918 3.918 0 0 0-.937 1.505l-.53 1.55c.28.113.501.337.61.618l1.543-.525a3.922 3.922 0 0 0 1.509-.94l.16-.16Z" fill="#e6f0ff"></path><path d="M3.97 8.141c.17.858.67 1.271 1.527 1.528a.187.187 0 0 1 0 .374c-.857.171-1.27.67-1.528 1.528a.187.187 0 0 1-.373 0c-.172-.858-.671-1.27-1.528-1.528a.187.187 0 1 1 0-.374c.857-.171 1.27-.67 1.527-1.528a.187.187 0 0 1 .374 0Z" fill="#e6f0ff"></path></svg>';

export default class IAPlugin extends Plugin {
  static get pluginName() {
    return 'IAPlugin';
  }

  init() {
    const editor = this.editor;

    Object.assign(window.CKEDITOR_TRANSLATIONS['pt-br'].dictionary, {
      'IA Label': 'IA',
    });
    Object.assign(window.CKEDITOR_TRANSLATIONS['es'].dictionary, {
      'IA Label': 'IA',
    });
    Object.assign(window.CKEDITOR_TRANSLATIONS['en'].dictionary, {
      'IA Label': 'AI',
    });

    editor.ui.componentFactory.add(IAPlugin.pluginName, () => {
      const button = new ButtonView();

      button.set({
        label: editor.t('IA Label'),
        withText: true,
        tooltip: false,
        labelStyle: 'color: #e6f0ff !important',
        icon,
      });

      button.extendTemplate({
        attributes: {
          style: 'background-color: #4474d4; color: #e6f0ff !important; border-radius: 4px;',
        },
      });

      button.on('execute', () => editor.fire('openModalIA'));

      return button;
    });
  }
}
